export enum EnumCorridorColor {
  GREEN = 'GREEN',
  LIGHTGREEN = 'LIGHTGREEN',
  ORANGE = 'ORANGE',
  RED = 'RED',
  BLACK = 'BLACK',
  NONE = 'NONE',
  GRAY = 'GRAY',
  BELOW_BLACK = 'BELOW_BLACK'
}
